<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
     
        <!-- Snackbar for notifications -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <div class="d-flex justify-end">
      <v-btn 
        color="brand onBrand--text"
        dark
        small
        class="mb-2"
        style="margin-right:0.5em;border-radius:8px;"
        @click="videoDialog = true"
      >
      <v-icon left>mdi-youtube</v-icon>
      Watch Tutorial
      </v-btn>
      </div>

        <!-- Main Card -->
        <v-card>
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title class="ml-2">Parent Worksheet</v-toolbar-title>
            </v-toolbar>
            <br>
            <v-row justify="center">
                <v-col sm="4" md="4" cols="12">
                    <v-autocomplete color="#0F2027" dense rounded required v-model="ay" :items="ay_list" item-text="ay"
                        item-value="id" label="Select Academic Year" outlined />
                </v-col>
                <v-col sm="4" md="4" cols="12">
                    <v-combobox v-model="registration_no" rounded :items="childrens" label="Select Child"
                        item-text="name" outlined dense prepend-icon="mdi-account-child-circle"></v-combobox>
                </v-col>
                <v-col sm="2" md="2" cols="12">
                    <v-btn class="mt-1 button" @click="getData()">Proceed</v-btn>
                </v-col>
            </v-row>
            <v-card max-width="400" class="mx-auto" v-if="academic_year">
                <v-container fluid>
                    <v-row dense align="center">
                        <v-card elevation="0" class="mx-auto">
                            <v-row align="center">
                                <v-card-text class="text-h5 font-weight-bold">Academic Year&nbsp; : {{ academic_year
                                    }}</v-card-text>
                            </v-row>
                        </v-card>
                        <v-card elevation="0" class="mx-auto">
                            <v-row align="center">
                                <v-card-text class="text-h5 font-weight-bold">Standard &nbsp; : {{ standard
                                    }}</v-card-text>
                            </v-row>
                        </v-card>
                        <v-card elevation="0" class="mx-auto">
                            <v-row align="center">
                                <v-card-text class="text-h5 font-weight-bold">Division &nbsp; : {{ division
                                    }}</v-card-text>
                            </v-row>
                        </v-card>
                    </v-row>
                </v-container>
            </v-card>
            <br>
        </v-card>
        <br> <br>
        <!-- Course List Display -->
        <v-card v-if="course_list.length > 0 && !tableOpen">
            <v-card-text>
                <v-row>
                    <v-col v-for="course in course_list" :key="course.course_offering_id" cols="12" md="4">
                        <v-card @click="openCourseDialog(course)">
                            <v-card-title>
                                <v-avatar>
                                    <v-icon color="#FFD700"> mdi-folder</v-icon>
                                </v-avatar>
                                {{ course.course_name }}</v-card-title>
                        </v-card>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <br> <br>
        <!-- Worksheet Dialog -->

        <v-card v-if="dialog && tableOpen && this.parent_worksheet_list != ''">
            <v-row>
                <v-card-title>
                    <span class=" headline">{{ selectedCourseName }}</span>
                </v-card-title>
                <v-spacer></v-spacer>
                <v-card-actions>
                    <v-btn class="mr-7" color="indigo darken-1" text @click="closeTable">Close</v-btn>
                </v-card-actions>
            </v-row>
            <v-card-text>

                <v-data-table :headers="headers" :items="filteredWorksheets" :search="search" class="mytable">
                    <template v-slot:top>
                        <v-toolbar flat dense color="white">

                            <v-spacer></v-spacer>
                            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
                            </v-text-field>
                            <span style="width: 20px;"></span></v-toolbar></template>
                    <template v-slot:item.attachment="{ item }">
                        <span v-if="item.attachment != null">
                            <a target="_blank" :href="basepath + item.attachment"><span
                                    style="color: indigo; cursor: pointer;">
                                    <strong>Attachment</strong>
                                </span></a>
                        </span>
                        <span v-else>-</span>
                    </template>
                    <template v-slot:[`item.assessmentTypeConfiglist`]="{ item }">
                        <div v-for="(sub, i) in item.assessmentTypeConfiglist" :key="i">
                            <span style="margin-left: 3px;"> {{ sub.name }} </span>

                        </div>

                    </template>
                    <!-- <template v-slot:item.attachment="{ item }">
                        <span v-if="item.attachment">
                            <a :href="item.attachment" target="_blank">
                                <span style="color: indigo; cursor: pointer;">
                                    <strong>Attachment</strong>
                                </span>
                            </a>
                        </span>
                        <span v-else>
                            <strong>--</strong>
                        </span>
                    </template> -->
                </v-data-table>
            </v-card-text>
            <!-- <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeTable">Close</v-btn>
            </v-card-actions> -->
        </v-card>


        <!-- Overlay for loading -->
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-dialog v-model="videoDialog" max-width="1000px">
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center grey lighten-4">
          <span style="color:black">WorkSheet Tutorial</span>
          <v-btn icon @click="videoDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-responsive :aspect-ratio="16/9">
           <iframe
              v-if="videoDialog"
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/WRaboc66Nyg?si=zPVHtFfqMgnYj3Ip"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </v-responsive>
        </v-card-text>
      </v-card>
    </v-dialog>
    </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

export default {
    components: {
        Breadcrumbs,
    },
    data: () => ({
        childrens: [],
        registration_no: "",
        // extraBreadcrumbItems: [


        // ],
        // breadcrumbClass: "breadcrumb-style1",
        valid: false,
        overlay: false,
        snackbar_msg: "",
        videoDialog:false,
        color: "",
        snackbar: false,
        search: "",
        standard: "",
        tableOpen: false,
        division: "",
        academic_year: "",
        parent_worksheet_list: [],
        basepath: null,
        headers: [
            { text: "Sr No", value: "srno" },
            { text: "Title", value: "title" },
            { text: "Assessment Types", value: "assessmentTypeConfiglist" },
            { text: "Post Date", value: "post_date" },
            { text: "Description", value: "description" },
            { text: "Attachment", value: "attachment" }
        ],
        course_list: [],
        course_model: null,
        col_list_new: [],
        ay_list: [],
        ay: "",
        dialog: false,
        selectedCourseId: null,
        selectedCourseName: ""
    }),
    computed: {
        filteredWorksheets() {
            return this.parent_worksheet_list.filter(worksheet => worksheet.course_offering_id === this.selectedCourseId);
        }
    },
    mounted() {
        this.onLoad();
        this.basepath = localStorage.getItem("awspath");
    },
    methods: {
        closeTable() {
            this.dialog = false;
            this.tableOpen = false; // Set tableOpen back to false when closing the table
        },
        getData() {
            const formData = {
                registration_no: this.registration_no.registration_number,
                ay: this.ay
            };
            this.overlay = true;

            axios.post("/Homework/worksheet_parent_homepage_get_data", formData)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.overlay = false;
                        this.standard = res.data.standard;
                        this.division = res.data.division;
                        this.academic_year = res.data.academic_year;
                        this.parent_worksheet_list = res.data.worksheets_list;
                        this.course_list = res.data.col_list;
                    } else if (res.data.flag == "NO") {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                    }
                })
                .catch((error) => {
                    console.error(error);
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        openFolderDialog(folder) {
            // Set dialog content based on the selected folder
            this.dialog = true;
        },
        onLoad() {
            this.overlay = true;
            axios.post("/Homework/homework_parent_homepage")
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.childrens = res.data.learners;
                        this.registration_no = this.childrens[0];
                        this.ay_list = res.data.ay_list;
                        this.ay = res.data.cay;
                    }
                })
                .catch((error) => {
                    console.error(error);
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        openCourseDialog(course) {
            this.selectedCourseId = course.course_offering_id;
            this.selectedCourseName = course.course_name;
            this.tableOpen = true;
            this.dialog = true;
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        }
    }
};
</script>

<style scoped>
/* Add your styles here */
.v-text-field {
    padding-top: 0px !important;
    padding-bottom: 0px !important;
    margin: 0px !important;
}

.mytable> :first-child {
    padding: 0px !important;
    margin: 0px !important;
}

.theme--light.v-datatable .v-datatable__actions {
    background-color: white !important;
}

.theme--light.v-datatable .v-data-table__headers {
    background-color: white !important;
}

.theme--light.v-datatable .v-datatable__actions .v-toolbar {
    background-color: white !important;
}

.theme--light.v-datatable .v-data-table__headers .v-data-table__wrapper {
    background-color: white !important;
}

.v-data-table .v-data-table__wrapper {
    height: auto !important;
}

.theme--light.v-datatable .v-datatable__actions .v-toolbar {
    padding-top: 0px !important;
    padding-bottom: 0px !important;
    margin: 0px !important;
}

.buttonSave {
    border: 2px solid #018d20 !important;
    color: #018d20;
    background: transparent !important;
    border-radius: 50px;
    margin: 0.5rem !important;
    text-align: center;
}

.buttonSave:hover {
    text-align: center;
    color: white !important;
    background: #018d20 !important;
    background: #018d20;
    background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027);
    background: linear-gradient(to right, #2c5364, #203a43, #0f2027);
}

.buttonExit {
    border: 2px solid #0f2027 !important;
    color: #df110a;
    background: transparent !important;
    border-radius: 50px;
    margin: 0.5rem !important;
    text-align: center;
}

.buttonExit:hover {
    text-align: center;
    color: white !important;
    background: #df110a !important;
    background: #df110a;
    background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027);
    background: linear-gradient(to right, #2c5364, #203a43, #0f2027);
}
</style>
